var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homepageWrapper"},on:{"click":function($event){$event.stopPropagation();return _vm.redirect()}}})}
var staticRenderFns = []

export { render, staticRenderFns }